import { Button } from "@/components/design-system/button";
import { classApi } from "../api/classApi";
import ClassForm from "../components/ClassForm";
import { useLinkableGrades } from "../hooks/useLinkableGrades";
import { ChevronLeft } from "lucide-react";
import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router";
import type { AdminClass } from "../types/class.types";

export default function ViewClassPage() {
  const navigate = useNavigate();
  const { id } = useParams<{ id: string }>();
  const [initial, setInitial] = useState<AdminClass | null>(null);
  const { grades, loading: gradesLoading } = useLinkableGrades();
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!id) {
      setLoading(false);
      return;
    }

    classApi
      .getClassById(id)
      .then(setInitial)
      .finally(() => setLoading(false));
  }, [id]);

  return (
    <div className="h-full flex flex-col">
      <div className="h-[68px] px-[32px] items-center flex gap-3">
        <Button
          type="button"
          variant="light"
          size="md"
          className="w-[40px] h-[40px] p-0 bg-white border border-[#EDEDED] rounded-[8px]"
          onClick={() => navigate(-1)}
          leftIcon={<ChevronLeft className="w-5 h-5" />}
        >
          <span className="sr-only">Back</span>
        </Button>
        <div className="text-[#1F1F1F] text-[16px] font-semibold">View Class</div>
      </div>
      <div className="flex-1 px-[32px] pb-[24px]">
        {loading ? (
          <p className="text-[16px] font-medium py-8">Loading…</p>
        ) : initial ? (
          <ClassForm
            mode="view"
            initial={initial}
            grades={grades}
            gradesLoading={gradesLoading}
            onClose={() => navigate(-1)}
          />
        ) : (
          <p className="text-[#ef4444] py-8">Class not found.</p>
        )}
      </div>
    </div>
  );
}
